/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class Product extends DaoModel {
  constructor(guid, id_external, name, commercial_name_alt1, commercial_name_alt2,
    commercial_name_alt3, commercial_description_alt1, commercial_description_alt2,
    commercial_description_alt3, long_commercial_description_alt1, long_commercial_description_alt2,
    long_commercial_description_alt3,
    out_of_stock, unit_cost, cost_price, reference_price, image, video, features,
    max_range_price, min_range_price, processing_speed, consumption_per_person,
    sold_by_weight, sale_weight_index, is_menu_enabled, is_managed, is_new, first_price,
    master_sale_format, sale_formats, point_of_sale_guid, group_of_product_pricing_guid,
    ignore_dynamic_visibility, product_master, tags) {
    super(guid);
    this.name = name || '';
    this.id_external = id_external || '';
    this.commercial_name_alt1 = commercial_name_alt1 || '';
    this.commercial_name_alt2 = commercial_name_alt2 || '';
    this.commercial_name_alt3 = commercial_name_alt3 || '';
    this.commercial_description_alt1 = commercial_description_alt1 || '';
    this.commercial_description_alt2 = commercial_description_alt2 || '';
    this.commercial_description_alt3 = commercial_description_alt3 || '';
    this.long_commercial_description_alt1 = long_commercial_description_alt1 || '';
    this.long_commercial_description_alt2 = long_commercial_description_alt2 || '';
    this.long_commercial_description_alt3 = long_commercial_description_alt3 || '';
    this.out_of_stock = out_of_stock || false;
    this.unit_cost = unit_cost || 0.0;
    this.cost_price = cost_price || 0.0; // Used only to read from it, not to update
    this.reference_price = reference_price || 0.0;
    this.image = image || undefined;
    this.video = video || undefined;
    this.features = features || [];
    this.max_range_price = max_range_price || null;
    this.min_range_price = min_range_price || null;
    this.processing_speed = processing_speed || 0.0;
    this.consumption_per_person = consumption_per_person || 0.0;
    this.sold_by_weight = sold_by_weight || false;
    this.sale_weight_index = sale_weight_index || null;
    this.is_menu_enabled = is_menu_enabled || false;
    this.is_managed = is_managed || false;
    this.is_new = is_new || false;
    this.first_price = first_price || 0.0;
    this.master_sale_format = master_sale_format || null;
    this.sale_formats = sale_formats ? Object.fromEntries(sale_formats.map((sale_format) => [sale_format.master_sale_format, sale_format.product])) : null;
    this.point_of_sale_guid = point_of_sale_guid || '';
    this.group_of_product_pricing_guid = group_of_product_pricing_guid || null;
    this.ignore_dynamic_visibility = ignore_dynamic_visibility || false;
    this.product_master = product_master || '';
    this.tags = tags || [];
  }

  static toInstance(props = {}) {
    return new Product(props.guid, props.id_external, props.name, props.commercial_name_alt1,
      props.commercial_name_alt2, props.commercial_name_alt3, props.commercial_description_alt1,
      props.commercial_description_alt2, props.commercial_description_alt3,
      props.long_commercial_description_alt1, props.long_commercial_description_alt2,
      props.long_commercial_description_alt3,
      props.out_of_stock, props.unit_cost, props.cost_price, props.reference_price, props.image, props.video,
      props.features, props.max_range_price, props.min_range_price, props.processing_speed,
      props.consumption_per_person, props.sold_by_weight, props.sale_weight_index,
      props.is_menu_enabled, props.is_managed, props.is_new, props.first_price, props.master_sale_format,
      props.sale_formats, props.point_of_sale, props.group_of_product_pricing, props.ignore_dynamic_visibility,
      props.product_master, props.tags);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      id_external: this.id_external,
      commercial_name_alt1: this.commercial_name_alt1,
      commercial_name_alt2: this.commercial_name_alt2,
      commercial_name_alt3: this.commercial_name_alt3,
      commercial_description_alt1: this.commercial_description_alt1,
      commercial_description_alt2: this.commercial_description_alt2,
      commercial_description_alt3: this.commercial_description_alt3,
      long_commercial_description_alt1: this.long_commercial_description_alt1,
      long_commercial_description_alt2: this.long_commercial_description_alt2,
      long_commercial_description_alt3: this.long_commercial_description_alt3,
      out_of_stock: this.out_of_stock,
      unit_cost: this.unit_cost,
      reference_price: this.reference_price,
      image: this.image,
      video: this.video,
      features: this.features,
      tags: this.tags,
      max_range_price: this.max_range_price,
      min_range_price: this.min_range_price,
      processing_speed: this.processing_speed,
      consumption_per_person: this.consumption_per_person,
      sold_by_weight: this.sold_by_weight,
      sale_weight_index: this.sale_weight_index,
      is_menu_enabled: this.is_menu_enabled,
      is_managed: this.is_managed,
      is_new: this.is_new,
      first_price: this.first_price,
      master_sale_format: this.master_sale_format,
      sale_formats: this.sale_formats,
      group_of_product_pricing: this.group_of_product_pricing_guid,
      point_of_sale: this.point_of_sale_guid,
      ignore_dynamic_visibility: this.ignore_dynamic_visibility,
      product_master: this.product_master
    };
  }

  serializeSaleFormats() {
    return {
      product_guid: this.guid,
      product_sale_format_list: [
        { master_sale_format: this.master_sale_format, product: this.guid },
        ...Object.entries(this.sale_formats).map((entry) => ({
          master_sale_format: entry[0],
          product: entry[1]
        }))
      ]
    };
  }

  get commercial_name() {
    return this.commercial_name_alt1;
  }

  get commercial_description() {
    return this.commercial_description_alt1;
  }

  get long_commercial_description() {
    return this.long_commercial_description_alt1;
  }

  getFormData() {
    const formData = new FormData();
    formData.append('guid', this.guid);
    formData.append('id_external', this.id_external);
    formData.append('name', this.name);
    formData.append('commercial_name_alt1', this.commercial_name_alt1);
    formData.append('commercial_name_alt2', this.commercial_name_alt2);
    formData.append('commercial_name_alt3', this.commercial_name_alt3);
    formData.append('commercial_description_alt1', this.commercial_description_alt1);
    formData.append('commercial_description_alt2', this.commercial_description_alt2);
    formData.append('commercial_description_alt3', this.commercial_description_alt3);
    formData.append('long_commercial_description_alt1', this.long_commercial_description_alt1);
    formData.append('long_commercial_description_alt2', this.long_commercial_description_alt2);
    formData.append('long_commercial_description_alt3', this.long_commercial_description_alt3);
    formData.append('out_of_stock', this.out_of_stock);

    if (this.is_managed) {
      formData.append('unit_cost', this.unit_cost);
      formData.append('reference_price', this.reference_price);
      formData.append('max_range_price', this.max_range_price);
      formData.append('min_range_price', this.min_range_price);
      formData.append('processing_speed', this.processing_speed);
      formData.append('consumption_per_person', this.consumption_per_person);
      formData.append('group_of_product_pricing', this.group_of_product_pricing_guid);
      formData.append('ignore_dynamic_visibility', this.ignore_dynamic_visibility);
    }
    if (this.image instanceof File) {
      if (this.image.size !== 0) {
        formData.append('image', this.image, this.image.name);
      }
    } else if (!this.image) {
      formData.append('image', '');
    }
    if (this.video instanceof File) {
      if (this.video.size !== 0) {
        formData.append('video', this.video, this.video.name);
      }
    } else if (!this.video) {
      formData.append('video', '');
    }
    if (this.features.length > 0) {
      this.features.forEach((feature) => {
        formData.append('features', feature);
      });
    }
    if (this.tags.length > 0) {
      this.tags.forEach((tag) => {
        formData.append('tags', tag);
      });
    }
    formData.append('sold_by_weight', this.sold_by_weight);
    if (this.sold_by_weight) {
      formData.append('sale_weight_index', this.sale_weight_index);
    }
    formData.append('is_menu_enabled', this.is_menu_enabled);
    formData.append('is_managed', this.is_managed);
    formData.append('is_new', this.is_new);
    formData.append('first_price', this.first_price);
    formData.append('master_sale_format', this.master_sale_format);
    formData.append('point_of_sale_guid', this.point_of_sale_guid);
    formData.append('product_master', this.product_master);
    return formData;
  }

  getReducedFormData() {
    const formData = new FormData();
    formData.append('guid', this.guid);
    formData.append('sold_by_weight', this.sold_by_weight);
    if (this.sold_by_weight) {
      formData.append('sale_weight_index', this.sale_weight_index);
    }
    formData.append('unit_cost', this.unit_cost);
    formData.append('processing_speed', this.processing_speed);
    formData.append('consumption_per_person', this.consumption_per_person);
    formData.append('reference_price', this.reference_price);
    formData.append('max_range_price', this.max_range_price);
    formData.append('min_range_price', this.min_range_price);
    formData.append('is_new', this.is_new);
    formData.append('is_menu_enabled', this.is_menu_enabled);
    formData.append('ignore_dynamic_visibility', this.ignore_dynamic_visibility);
    formData.append('product_master', this.product_master);
    return formData;
  }

  getCommercialName(language) {
    return this[`commercial_name_${language}`];
  }

  getFirstName(language) {
    if (language) return this.getCommercialName(language) || this.name;
    return this.commercial_name || this.name;
  }

  get isConfigured() {
    const required_fields = [
      this.master_sale_format,
      this.commercial_name_es,
    ];
    const required_managed_fields = [
      this.min_range_price,
      this.max_range_price,
      this.group_of_product_pricing_guid,
    ];

    const valid_required_fields = required_fields.every((el) => !!el);
    const valid_managed_required_fields = this.is_managed ? required_managed_fields.every((el) => !!el) : true;
    const valid_weight_field = this.sold_by_weight ? !!this.sale_weight_index : true;
    return valid_required_fields && valid_managed_required_fields && valid_weight_field;
  }
}
